/**
 * ¿SE MUESTRA EL AVISO DE «TOPE DEL PLAN» EN LA BANDEJA? (20-oct-2026). PURA.
 *
 * El aviso POR CHAT ya existe («Sin responder · tope del plan», `0364529`, `esperaDeRespuesta.js`).
 * Esto es el aviso permanente de la bandeja: el asistente dejó de responder porque la organización
 * llegó al tope de mensajes del mes. Usa la MISMA cuenta que el corte del backend
 * (`planValidation.checkMessageLimit`: `usage.messagesThisMonth` contra el total efectivo del plan
 * más los add-ons, y sólo si `featureFlags.strictPlanEnforcement !== false`), vía
 * `calculateUsagePercentages`, que es la de la pantalla de facturación. Se va solo en cuanto el uso
 * vuelve a estar por debajo del total (cambio de mes, subida de plan o add-on).
 *
 * Lo ve sólo quien puede gestionar el plan: el mismo gate que `pages/Billing.jsx`.
 */
import { calculateUsagePercentages } from './planHelpers';

/** El gate de `Billing.jsx`, para que el aviso no le hable a quien no puede hacer nada. */
export function puedeGestionarPlan(context) {
  if (!context) return false;
  return context.mode === 'organization'
    && (context.member?.role === 'owner' || context.member?.permissions?.canManageBilling === true);
}

/**
 * @param {object|null} orgData  el documento de la organización
 * @param {object} context      el de `useOrganization()`
 * @returns {{ mostrar: boolean, usados?: number, total?: number }}
 */
export function debeMostrarBannerTope(orgData, context) {
  if (!orgData || !puedeGestionarPlan(context)) return { mostrar: false };
  if (orgData.featureFlags?.strictPlanEnforcement === false) return { mostrar: false };
  const m = calculateUsagePercentages(orgData).messages;
  if (!m || !Number.isFinite(m.total) || m.total <= 0) return { mostrar: false };
  return { mostrar: m.used >= m.total, usados: m.used, total: m.total };
}
